import { EmptyState } from '@kerfjs/ui/empty-state';
import { List } from '@kerfjs/ui/list';
import { ValueTable, ValueTableRow } from '@kerfjs/ui/value-table';
import type { SafeHtml } from 'kerfjs';

import { CurrencyAmount } from '../../../components/currency-amount.js';
import type { OrgSavingsT } from '../../../data/api.js';
import { matchesSettingsSearch } from '../../../lib/settings-search.js';

export function SavingsByVendor({ savings: s, query = '' }: { savings: OrgSavingsT; query?: string }): SafeHtml {
  const vendors = s.byVendor.filter((v) => matchesSettingsSearch([v.vendorName], query));
  return (
    <section aria-label="Savings by Vendor">
      <List gap="xs">
        {vendors.length === 0 ? (
          <EmptyState title={query.trim() === '' ? 'No recorded outcomes yet' : 'No matching vendors'} />
        ) : (
          <ValueTable label="Savings by Vendor">
            {vendors.map((v) => (
              <ValueTableRow label={v.vendorName} value={<CurrencyAmount value={v.savings} currency={s.base} />} />
            ))}
          </ValueTable>
        )}
      </List>
    </section>
  );
}
